import React from 'react';

const Membranes = () => {
  const membraneProducts = [
    { name: "UF Membrane", image: "images/jalistep/uf membrane.jpeg" },
    { name: "vontron membrane 8040", image: "images/jalistep/vontron membrane 8040.jpeg" },
    { name: "vontron membrane 4040", image: "images/jalistep/vontron membrane 4040.jpeg" },
    { name: " washable UF Membrane", image: "images/jalistep/washable uf membrane.png" },
    { name: "filmtec Membrane", image: "images/jalistep/filmtec membrane.jpeg" },    
    { name: "Membrane Housing", image: "images/jalistep/membrane housing.jpeg" },
    { name: "Ro Membrane", image: "images/jalistep/pic23 (64).png" }
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 text-dark">MEMBRANES</h1>
      
      <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
        {membraneProducts.map((product, index) => (
          <div key={index} className="col">
            <div className="card h-100 shadow-sm border-0 text-center">
              <img 
                src={product.image} 
                alt={product.name}
                className="card-img-top p-3"
                style={{ height: "200px", objectFit: "contain" }}
              />
              <div className="card-body">
                <h5 className="card-title text-cyan m-0">{product.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Membranes;